import { SESSIONS_TEST_IDS } from '@/components/admin/sessions/contracts';
import { Button } from '@/components/ui/button';
import { sessionDate } from '@/lib/session-labels';

/**
 * The banner a session in the trash is read under (§12.5).
 *
 * « Une session en corbeille reste OUVRABLE en lecture sous un bandeau qui donne
 * sa date d'effacement. » The screen underneath is unchanged: what a trashed
 * session shows is what it showed, because the trash is a thirty-day delay and
 * not a redaction - and an operator who put one there by mistake has to be able
 * to see what they are restoring.
 *
 * Yellow rather than red: the session is not gone, and nothing on this banner is
 * irreversible. Red is kept for the box that puts it here in the first place.
 */

export interface TrashedBannerProps {
  /** The stamp `deletedAt` carries; the banner is not mounted without one. */
  readonly deletedAt: string;
  readonly onRestore: () => void;
  readonly busy: boolean;
}

export function TrashedBanner({ deletedAt, onRestore, busy }: TrashedBannerProps) {
  return (
    <div
      data-testid={SESSIONS_TEST_IDS.trashedBanner}
      className="flex flex-wrap items-center gap-4 rounded-md border-2 border-jaune bg-jaune-tint px-4 py-3"
    >
      <p className="min-w-0 flex-1 text-jaune-deep text-sm">
        Cette session est à la corbeille depuis le{' '}
        <b className="font-semibold">{sessionDate(deletedAt)}</b>. Elle reste lisible ici, et sera
        effacée définitivement trente jours après cette date.
      </p>
      <Button type="button" variant="outline" size="sm" disabled={busy} onClick={onRestore}>
        Restaurer
      </Button>
    </div>
  );
}
